import * as thermalMath from '../../utils/thermal-math';

import { getItemByNid, getValue } from '../../utils/calculations-helper';

import { buildUIStringArray, getCalculation } from '../../utils/index';

import { CALCULATION_TYPE_PLANE, CALCULATION_CALCULATE_RESULTS, updateResults } from '../../modules/calculation';

export function createMiddleware() {
  return store => next => action => {
    const { type, payload } = action;
    const {
      claddings,
      energy,
      environments,
      materials,
      mediums,
      products,
      project,
      app,
      translations,
      settings,
    } = store.getState();

    const ui = buildUIStringArray(app.language, translations.data);

    switch (type) {
      case CALCULATION_CALCULATE_RESULTS:

        const c = getCalculation(project);

        if(c.type === CALCULATION_TYPE_PLANE) {
          // calculate
          next(action);

          // console.log('------>',thermalMath.solveLambdaArray([200,400,600,800],[0.04,0.08,0.14,0.23] ) );

          var t0 = performance.now();

          let o = {};
          o.sectionResults = [];

          for(let i = 0; i < c.sections.length; i++)  {
            let s = c.sections[i];

            let material = getItemByNid(s.material, materials);
            let content = getItemByNid(s.content, mediums);
            let energySource = getItemByNid(c.energyType, energy);
            let environment = getItemByNid(s.environmentType, environments);
            let cladding = getItemByNid(s.cladding, claddings);

            let layers = [];
            let maxTemperatures = [];
            let layerProducts = [];
            let nominalDensity = [];
            let lambdas = [ [ getValue(material['Thermal-conductivity'], 'float') ]];
            let thicknesses = [ [getValue(s.thickness, 'mmToMeters')] ];

            const targetDef = {
              type: 'plane',
              actualType: c.type,
              direction: s.direction,
              position: s.position,
              shape: s.shape,
              height: getValue(s.height, 'float'),
              length: getValue(s.height, 'float'),
              width: getValue(s.width, 'float'),
              claddingSupport: s.supportOfCladding,
              claddingSupportInfluence: getValue(s.influenceOnHeatloss, 'float') * s.spacersPerM,
              mechanicalFasteners: s.mechanicalFastener,
              mechanicalInfluence: getValue(s.mechanicalInfluence, 'float') * s.mechanicalPerM,
              solarRadiation: c.calculateSolarRadiation,
              solarRadiationValue: s.environmentSolarRadiation * getValue(s.emissivity, 'float'),

            };

            for(let j = 0; j < s.insulationLayers.length; j++) {
              layers.push(getItemByNid(s.insulationLayers[s.insulationLayers.length - j - 1].selectedItem, products));
              layers[j].thickness = s.insulationLayers[s.insulationLayers.length - j - 1].selectedThickness;
              lambdas.push([getValue(layers[j].a, 'float'), getValue(layers[j].b, 'float'), getValue(layers[j].c, 'float'), getValue(layers[j].d, 'float')]);
              thicknesses.push(getValue(layers[j].thickness, 'mmToMeters'));

              maxTemperatures.push({mst: getValue(layers[j].MST, 'int'), facing: getValue(layers[j]['Facing-MST'], 'int'), net: getValue(layers[j]['Net-MST'], 'int')});

              nominalDensity.push(getValue(layers[j]['nominal-density'], 'float'));

              if(layers[j].hasOwnProperty('custom') && layers[j].custom === 'true') {
                layerProducts.push({name: '*' + layers[j]['name'], thickness: layers[j].thickness});
              } else {
                layerProducts.push({name: layers[j]['Product-name'], thickness: layers[j].thickness});
              }
            }

            let uninsulatedHeatLossResults = thermalMath.heatLossIterative('plane', getValue(material.Emissivity, 'float'),
                                    getValue(s.temperature, 'float'), getValue(s.environmentTemperature, 'float'),  [ getValue(material['Thermal-conductivity'], 'float') ],
                                    getValue(s.environmentAirVelocity, 'float'), [getValue(s.thickness, 'mmToMeters')], [0], [0], true, {...targetDef, uninsulated: true});

            let heatLossResults;
            if(s.noInsulation) {
              heatLossResults = uninsulatedHeatLossResults;
            } else {
              heatLossResults = thermalMath.heatLossIterative('plane', getValue(s.emissivity, 'float'),
                                      getValue(s.temperature, 'float'), getValue(s.environmentTemperature, 'float'),  lambdas,
                                      getValue(s.environmentAirVelocity, 'float'), thicknesses, [0], [0], false, targetDef);
            }

            o.sectionResults.push({heatloss: heatLossResults[2], alphae: heatLossResults[1]});
            o.sectionResults[i].surfaceTemperature = heatLossResults[3][ heatLossResults[3].length - 1 ];
            o.sectionResults[i].uninsulatedHeatLoss = (uninsulatedHeatLossResults[2]);
            o.sectionResults[i].uninsulatedSurfaceTemperature = uninsulatedHeatLossResults[3][0];
            o.sectionResults[i].dewPoint = thermalMath.dewPoint(getValue(s.environmentTemperature, 'float'), getValue(s.environmentHumidity, 'float'));

            o.sectionResults[i].material = (material.hasOwnProperty('custom') && material.custom) ? material.name : material;// :(material[app.language]!==false)?material[app.language]:material['English'];
            o.sectionResults[i].energySource = (energySource.hasOwnProperty('custom') && energySource.custom) ? energySource.name : energySource;// (energySource[app.language]!==false)?energySource[app.language]:energySource['English'];
            o.sectionResults[i].content = (content.hasOwnProperty('custom') && content.custom) ? content.name : content;// (content[app.language]!==false)?content[app.language]:content['English'];
            o.sectionResults[i].alphaR = heatLossResults[4][0];
            o.sectionResults[i].alphaK = heatLossResults[4][1];
            o.sectionResults[i].addition = heatLossResults[4][3];
            o.sectionResults[i].joint = heatLossResults[4][4];

            if(s.cladding == -1) {
              o.sectionResults[i].cladding = ui['GENERAL-OTHER_CLADDING'];
            } else if(s.cladding == -2) {
              o.sectionResults[i].cladding = ui['GENERAL-NO_CLADDING'];
            } else if(cladding && cladding.hasOwnProperty('custom') && cladding.custom) {
              o.sectionResults[i].cladding = cladding.name;
            } else {
              o.sectionResults[i].cladding = cladding;// (cladding[app.language]!==false)?cladding[app.language]:cladding['English'];
            }

            o.sectionResults[i].nominalWeight = thermalMath.calculateInsulationWeight('plane', 0, 0, 0, thicknesses, 1, 1, nominalDensity);
            o.sectionResults[i].layers = [];
            for(let j = 0; j < layers.length; j++) {
              o.sectionResults[i].layers.push( { 'surfaceTemperature': heatLossResults[3][j + 1], 'thermalConductivity': heatLossResults[0][j] } );
              o.sectionResults[i].layers[j].warnings = [];
              o.sectionResults[i].layers[j].product = layerProducts[j];

              if(maxTemperatures[j].mst <= heatLossResults[3][j]) {
                o.sectionResults[i].layers[j].warnings.push(ui['INSULATION-MATERIAL_MST_ALERT']);
              }
              if(maxTemperatures[j].facing <= heatLossResults[3][j + 1] && maxTemperatures[j].facing !== NaN) {
                o.sectionResults[i].layers[j].warnings.push(ui['INSULATION-FACING_MST_ALERT']);
              }
              if(maxTemperatures[j].net <= heatLossResults[3][j + 1] && maxTemperatures[j].net !== NaN) {
                o.sectionResults[i].layers[j].warnings.push(ui['INSULATION-NET_MST_ALERT']);
              }
            }

            if(s.supportOfCladding) {
              o.sectionResults[i].heatloss = o.sectionResults[i].heatloss + ( o.sectionResults[i].heatloss * s.influenceOnHeatloss ) / 100;
            }

            o.sectionResults[i].coEmissionReduction = Math.abs( getValue( (thermalMath.emissionCO2('plane', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, o.sectionResults[i].uninsulatedHeatLoss, getValue(s.width, 'float'), getValue(s.height, 'float'), 0) - thermalMath.emissionCO2('plane', getValue(energySource['CO2-emission-per-W'], 'float'), c.energyOperationTime, o.sectionResults[i].heatloss, getValue(s.width, 'float'), getValue(s.height, 'float'), 0) ), 'gToKg') );
            o.sectionResults[i].annualSavingsKwh = Math.abs( getValue( (thermalMath.annualCostKwh('plane', uninsulatedHeatLossResults[2], c.energyOperationTime, getValue(s.width, 'float'), getValue(s.height, 'float'), 0) - thermalMath.annualCostKwh('plane', o.sectionResults[i].heatloss, c.energyOperationTime, getValue(s.width, 'float'), getValue(s.height, 'float'), 0) ), 'wToKwh') );
            o.sectionResults[i].annualSavings = Math.abs( getValue( (thermalMath.annualCost('plane', uninsulatedHeatLossResults[2], c.energyPrice, c.energyOperationTime, getValue(s.width, 'float'), getValue(s.height, 'float'), 0) - thermalMath.annualCost('plane', o.sectionResults[i].heatloss, c.energyPrice, c.energyOperationTime, getValue(s.width, 'float'), getValue(s.height, 'float'), 0) ), 'cToE') );

            if(app.country === 'Denmark' || app.country === 'Sweden' || (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1) ) {
                // calculateUValues(targetType, heatLoss, mediumTemp, outsideTemp, pipeDiameter, rectDuctWidth, rectDuctHeight, klasse:Object)
              let uKlasse = thermalMath.calculateUValues('plane', o.sectionResults[i].heatloss, s.temperature, s.environmentTemperature, 0, 0, 0, s.klasse, settings, (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1), app.country);
              o.sectionResults[i].uKlasseUnit = 'W/m²K';
              o.sectionResults[i].uKlasse = uKlasse[0];
              o.sectionResults[i].uKlasseNorm = uKlasse[1];
            }

            o.sectionResults[i].warnings = {surface: [], object: []};

            if( nominalDensity.findIndex(item => item < 80) !== -1 && s.direction === 'vert'  && getValue(s.temperature, 'float') >= 100 ) {
              o.sectionResults[i].layers[layers.length - 1].warnings.push(
                ui['WARNING_MATERIAL_DENSITY']
              );
            }
            if( !s.noInsulation && ( o.sectionResults[i].dewPoint + getValue(settings['Dew-point-tolerance'], 'int') ) >= heatLossResults[3][layers.length]) {
              o.sectionResults[i].warnings.surface.push(ui['INSULATION-DEWPOINT_ALERT']);
            }
            if( s.noInsulation && ( o.sectionResults[i].dewPoint + getValue(settings['Dew-point-tolerance'], 'int') ) >= heatLossResults[3][0]) {
              o.sectionResults[i].warnings.surface.push(ui['INSULATION-DEWPOINT_ALERT']);
            }
            if(getValue(material['Maximum-service-temperature'], 'int') <= getValue(s.temperature, 'float')) {
              o.sectionResults[i].warnings.object.push(ui['INSULATION-OBJECT_MATERIAL_MST_ALERT']);
            }
            if(cladding && getValue(cladding['MST'], 'int') <= heatLossResults[3][layers.length]) {
              o.sectionResults[i].warnings.surface.push(ui['INSULATION-CLADDING_ALERT']);
            }

            // console.log((s !== undefined))
            if (s && s.shape && s.shape !== 'square') {
              o.heatloss = o.sectionResults[0].heatloss * (Math.pow( (getValue(c.sections[0].height, 'float') / 2), 2 ) * Math.PI);
              o.uninsulatedHeatLoss = o.sectionResults[0].uninsulatedHeatLoss * (Math.pow( (getValue(c.sections[0].height, 'float') / 2), 2 ) * Math.PI);
            } else {
              o.heatloss = o.sectionResults[0].heatloss * getValue(c.sections[0].width, 'float') * getValue(c.sections[0].height, 'float');
              o.uninsulatedHeatLoss = o.sectionResults[0].uninsulatedHeatLoss * getValue(c.sections[0].width, 'float') * getValue(c.sections[0].height, 'float');
            }
          }


          var t1 = performance.now();
          // console.log("Call to doSomething took " + (t1 - t0) + " milliseconds.");

          // PIPE
          // o.freezingStartInHours
          // o.frozenToValue
          // o.temperatureChange
          // o.totalHeatLoss
          // o.uninsulatedTotalHeatLoss
          // 0.timeToFinalTemperature

          store.dispatch(updateResults(o));
        } else {
          next(action);
        }

        break;

      default:
        next(action);
    }
  };
}
